export const firebase = {
  apiKey: "AIzaSyAj3bcmpKwyDSS6ZZvYr7kQskM3O1UptJw",
  authDomain: "auth.mybodyecology.com",
  // authDomain: "my-body-ecology-260112.firebaseapp.com",
};